import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a269db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "skeleton-box" }

import {Skeleton} from 'vant';
import CustomEmpty from '@/components/CustomEmpty.vue';
import InfoItem from './InfoItem.vue';


const __default__ = {
  name: 'InfoList',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    firstPageFetching: { type: Boolean },
    firstPageFinished: { type: Boolean },
    firstPageError: null,
    firstPageRefetch: null,
    infoList: null,
    toDetail: null,
    isRefreshing: { type: Boolean },
    ifRefetchTagList: null
  },
  setup(__props: any) {

const props = __props as {
  firstPageFetching: boolean;
  firstPageFinished: boolean;
  firstPageError: any;
  firstPageRefetch: any;
  infoList: InfoItem[];
  toDetail:(infoId: number, role: number) => void;
  isRefreshing: boolean;
  ifRefetchTagList: () => void;
}



// 点击刷新重试
const errorBtnClick = () => {
  props.firstPageRefetch();
  props.ifRefetchTagList();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "list-container",
    style: _normalizeStyle(
      ((!__props.firstPageFinished || __props.firstPageFetching) && !__props.isRefreshing) ||// 骨架屏展示时背景是白色
        (((__props.firstPageFinished && !__props.firstPageFetching) ||
          __props.isRefreshing) && __props.infoList?.length > 0)// 有列表数据是背景色为白色
        ? 'background-color: #ffffff;'
        : 'background-color: transparent;'
    )
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Skeleton), {
        title: "",
        row: 2,
        avatar: "",
        "avatar-shape": "square"
      }),
      _createVNode(_unref(Skeleton), {
        title: "",
        row: 2,
        avatar: "",
        "avatar-shape": "square"
      }),
      _createVNode(_unref(Skeleton), {
        title: "",
        row: 2,
        avatar: "",
        "avatar-shape": "square"
      }),
      _createVNode(_unref(Skeleton), {
        title: "",
        row: 2,
        avatar: "",
        "avatar-shape": "square"
      }),
      _createVNode(_unref(Skeleton), {
        title: "",
        row: 2,
        avatar: "",
        "avatar-shape": "square"
      }),
      _createVNode(_unref(Skeleton), {
        title: "",
        row: 2,
        avatar: "",
        "avatar-shape": "square"
      }),
      _createVNode(_unref(Skeleton), {
        title: "",
        row: 2,
        avatar: "",
        "avatar-shape": "square"
      }),
      _createVNode(_unref(Skeleton), {
        title: "",
        row: 2,
        avatar: "",
        "avatar-shape": "square"
      })
    ], 512), [
      [_vShow, (!__props.firstPageFinished || __props.firstPageFetching) && !__props.isRefreshing]
    ]),
    ((__props.firstPageFinished && !__props.firstPageFetching) || __props.isRefreshing)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.infoList?.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.infoList, (item, index) => {
                return (_openBlock(), _createBlock(InfoItem, {
                  key: item.informationId,
                  "is-top": item.hasTopTitle,
                  "no-border": index + 1 === __props.infoList.length,
                  "item-info": item,
                  "to-detail": __props.toDetail
                }, null, 8, ["is-top", "no-border", "item-info", "to-detail"]))
              }), 128))
            : (__props.firstPageError)
              ? (_openBlock(), _createBlock(CustomEmpty, {
                  key: 1,
                  type: "error",
                  class: "empty",
                  "on-click-btn": errorBtnClick
                }))
              : (__props.infoList?.length === 0 && !__props.isRefreshing)
                ? (_openBlock(), _createBlock(CustomEmpty, {
                    key: 2,
                    type: "none",
                    class: "empty",
                    description: "哎呀！这里空空的！"
                  }))
                : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 4))
}
}

})